var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccordianCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 27.5,
    y: 27.5,
    width: 26.7399,
    height: 27,
    rx: 3.5,
    transform: "rotate(-180 27.5 27.5)",
    stroke: "#D2D2D2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.85406 11.9666L13.2007 16.3132C13.7141 16.8266 14.5541 16.8266 15.0674 16.3132L19.4141 11.9666",
    stroke: "#1C1C1C",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccordianCloseIcon);
export default __webpack_public_path__ + "static/media/AccordianCloseIcon.1bbe0f76ed5378c82be8ab6575f39851.svg";
export { ForwardRef as ReactComponent };